import { createSlice } from "@reduxjs/toolkit"

const basicInformationSlice = createSlice({
  name: "basicInformation",
  initialState: {
    userDetails: null,
  },
  reducers: {
    addUserDetails(state, action) {
      state.userDetails = action.payload
    },
    removeUser(state, action) {
      state.userDetails = null
    },
  },
})

export default basicInformationSlice.reducer

export const { addUserDetails, removeUser } = basicInformationSlice.actions
